import React from 'react';
import PropTypes from 'prop-types';
import { Grid, CircularProgress } from '@mui/material';
import _ from 'lodash';
import DetailsTable from '../DetailsTable';
import { DetailsContainer, LoadContainer, IconClose, Details } from './styles';
import { DetailPopup } from 'shared/components';

const HEADERS = ['Npo/Report', 'Reach', 'Allocation', 'Measurement'];

const HEAD_TO_COLUMN = {
  'Npo/Report': 'report',
  Reach: 'reach',
  Allocation: 'allocation',
  Measurement: 'measurement'
};

const CardDetails = ({ loading, list, onClose }) => {
  const [sortBy, setSortBy] = React.useState('allocation');
  const [sortOrder, setSortOrder] = React.useState('desc');

  const onClickHeader = head => {
    const order =
      sortBy === HEAD_TO_COLUMN[head] && sortOrder === 'desc' ? 'asc' : 'desc';
    setSortBy(HEAD_TO_COLUMN[head]);
    setSortOrder(order);
  };

  const rows = [...list];

  rows.forEach((row, idx) => {
    rows[idx].details = _.orderBy(row.details, sortBy, sortOrder);
  });

  return (
    <Details>
      <IconClose onClick={onClose}/>
      <DetailsContainer>
        <Grid item xs={12}>
          {!loading && rows && rows.length > 0 && (
            <DetailsTable
              rows={rows}
              headers={HEADERS}
              onClickHeader={onClickHeader}
            />
          )}
          {loading && (
            <LoadContainer>
              <CircularProgress />
            </LoadContainer>
          )}
        </Grid>
      </DetailsContainer>
    </Details>
  );
};

CardDetails.propTypes = {
  loading: PropTypes.bool,
  list: PropTypes.array,
  onClose: PropTypes.func
};

export default CardDetails;
